import axios from "../api";
export const googleLogin = async (token) => {
    const res = await axios.post("/auth/login", { token });
    console.log("res", res.data);
    return res.data;
};
//# sourceMappingURL=googleLogin.js.map